import $ from "jquery";
import { createGuid } from "#scripts/general_functions";
import language from "#scripts/translation";
import { categoryitem } from "#templates/modules/categorylisting_template";

export const getStoredNav = () => {
	/*
		Gets the categories from SessionStorage, parse them and return as JSON
		*/
	return JSON.parse(sessionStorage.getItem("aim-categories"));
};

export const categoriesFront = (moreText = "Se mer", lessText = "Se færre", cardDesign = "") => {
	$("body").on("click", "button.category__card__more__button", () => {
		document.querySelector(".category__cards").classList.toggle("closed");
		document.querySelector(".category__card__more__button").classList.toggle("open");
		if (document.querySelector(".category__card__more__button").classList.contains("open")) {
			document.querySelector(".category__card__more__button__text").innerText = lessText;
		} else {
			document.querySelector(".category__card__more__button__text").innerText = moreText;
		}
	});

	const moduleGuid = createGuid();
	const navs = getStoredNav();
	const navCards = [];

	if (navs?.length > 0) {
		for (const nav of navs) {
			if (!nav?.hideCategory) {
				let link = `/nav/${nav.full_url}`;
				if (nav?.externallink?.length > 0) {
					link = nav.externallink;
				}

				navCards.push({
					item: categoryitem({
						title: nav.previewItem,
						description: nav.desc,
						link,
					}),
				});
			}
		}
	}

	// moved this css here to be able to set the value of the nth-child(n + 7) dynamicaly
	const hideAfter = window.serverdata.configMeta.aim.style?.module?.categorycard__hideafter_mobile + 1 || 7;
	const maxWidth = "768px";
	const styleSheet = document.createElement("style");
	document.head.appendChild(styleSheet);
	styleSheet.sheet.insertRule(`@media (max-width: ${maxWidth}) {
      .closed .category__card__item:nth-child(n + ${hideAfter}) {
        display: none;
      }
    }`);

	const moreTitle = language("CARDS_SEEALL") !== "CARDS_SEEALL" ? language("CARDS_SEEALL") : moreText !== "" ? moreText : "Se flere";
	const returnHtml = `
  <section  id="module__cards_${moduleGuid}" class="module__category__cards ${cardDesign} p-md-0 justify-content-md-center">
    <div class="container p-0">
        <div class="category__cards closed" id="cards_${moduleGuid}">
          ${navCards.map((e) => e.item).join("")}
        </div>
        <div class="row">
            <div class="col text-right">
                ${navs.length > hideAfter
			? `<div class="category__card__more__container">
                    <button class="category__card__more__button" href="#"><span class="category__card__more__button__text">${moreTitle}</span><span class="material-icons-outlined notranslate category__card__more__icon">&#xe5cf;</span></button>
                </div>`
			: ""
		}
            </div>
        </div>
    </div>
  </section>`;

	// document.getElementById('categorylisting__more').addEventListener('click', function () {alert("Hey")});

	return returnHtml;
};
